import { isValidElement } from "react";
import { renderToString } from "react-dom/server";

export const globalFilterFn = (row, columnId, filterValue) => {
  const value = row.getValue(columnId);
  if (!value) return false;

  // if is a react element, then render it to string, so it can be searched
  if (isValidElement(value)) {
    const htmlString = renderToString(value);
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return (doc.body.textContent || doc.body.innerText)
      .toLowerCase()
      .includes(filterValue.toLowerCase());
  }

  return value
    .toString()
    .toLowerCase()
    .includes(filterValue.toString().toLowerCase());
};

export default globalFilterFn;
